// Standardtekst-maler for videre undersøkelser
// Kategorisert etter NS 3600-krav

export const videreUndersokelserMaler = {
  // ==========================================
  // INNVENDIGE UNDERSØKELSER
  // ==========================================
  loft: {
    type: 'innvendig',
    kategori: 'loft',
    navn: 'Loft-kontroll / undertak',
    arsak: '(NS 3600 pkt. 6.1): Ikke synlig/tilgjengelig fra inspeksjonspunkt. Ventilasjonsløsning, luftespalter og lufting ved møne/takfot er ikke verifisert.',
    omfang: `Innvendig undersøkelse påkrevd: Kontroll fra loft/undertak for å verifisere at kravene i TEK17 §13-3 (ventilasjon av kalde loft) og NS 3600 pkt. 6.1 er oppfylt.

Undersøkelsen bør omfatte:
- Luftespalter ved takfot (min. 50mm)
- Ventilasjonsåpninger ved møne
- Isolasjonstykkelse og utførelse
- Tetthet av dampsperre
- Fukt- og muggkontroll i trekonstruksjon`,
    metode: 'Visuell inspeksjon fra loft/undertak med foto-dokumentasjon. Eventuell fuktmåling i treverk.',
    kostnad_min: 5000,
    kostnad_max: 12000,
    prioritet: 'kritisk'
  },

  krypkjeller: {
    type: 'innvendig',
    kategori: 'krypkjeller',
    navn: 'Krypkjeller / kryprom',
    arsak: '(NS 3600 pkt. 4.5): Krypkjeller/kryprom ikke tilgjengelig for inspeksjon.',
    omfang: `Innvendig undersøkelse påkrevd: Kontroll av kryprom/krypkjeller for å verifisere:

- Fuktforhold (fuktmåling i treverk, anbefalt <16%)
- Ventilasjon (min. 1/500 av etasjeareal, jf. TEK17 §13-3)
- Bærekonstruksjon (råte, insektangrep, setninger)
- Grunnmur (sprekker, fuktinntrenging)
- Drenering og fuktsikring mot grunnen
- Radon-tiltak (tetthet mot grunnen)

Ved mistanke om alvorlige fuktskader kan destruktiv prøvetaking være nødvendig.`,
    metode: 'Visuell inspeksjon med krypeluke/tilgang. Fuktmåling i bærebjelker. Foto-dokumentasjon.',
    kostnad_min: 8000,
    kostnad_max: 15000,
    prioritet: 'kritisk'
  },

  vatrom: {
    type: 'innvendig',
    kategori: 'vatrom',
    navn: 'Våtrom - innvendig kontroll',
    arsak: '(NS 3600 pkt. 7.2): Membran/tetting ikke synlig. Anbefalt kontroll bak fliser/paneler for å verifisere membranløsning og utførelse.',
    omfang: `Innvendig kontroll bør omfatte:

- Tilstand på membran (kan kreve prøveåpning)
- Fall til sluk (min. 1:100)
- Slukløsninger (tette mansjetter)
- Hjørneløsninger og gjennomføringer
- Fuktmåling i underliggende konstruksjon (ved mistanke om lekkasje)

VIKTIG: Prøveåpning anbefales primært hvis det er synlige tegn på fuktskader (misfarging, løse fliser, lukt).`,
    metode: 'Ikke-destruktiv fuktmåling først. Prøveåpning kun ved konkret mistanke.',
    kostnad_min: 6000,
    kostnad_max: 18000,
    prioritet: 'anbefalt'
  },

  // ==========================================
  // FUKTUNDERSØKELSER
  // ==========================================
  fukt_kapasitiv: {
    type: 'fukt',
    kategori: 'fukt_kapasitiv',
    navn: 'Fuktmåling (kapasitiv)',
    arsak: 'Mistanke om fukt i konstruksjon basert på synlige tegn (misfarging, lukt, kondensering).',
    omfang: `Ikke-destruktiv fuktmåling med kapasitivt instrument:

- Måling i overflate (maling, tapet, panel)
- Kontroll av kritiske punkter (hjørner, vinduer, gulvlister)
- Kartlegging av fuktig område (utbredelse)

Verdier:
- <15%: Tørt, akseptabelt
- 15-20%: Forhøyet, overvåkes
- >20%: Kritisk, nærmere undersøkelse nødvendig`,
    metode: 'Kapasitiv fuktmåler (ikke-destruktiv). Foto-dokumentasjon av målinger.',
    kostnad_min: 3000,
    kostnad_max: 8000,
    prioritet: 'anbefalt'
  },

  termografi: {
    type: 'fukt',
    kategori: 'termografi',
    navn: 'Termografering',
    arsak: 'Mistanke om kuldebroer, lekkasjer eller isolasjonssvikt.',
    omfang: `Termografisk kartlegging for å identifisere:

- Kuldebroer i yttervegger
- Luftlekkasjer ved vinduer/dører
- Isolasjonssvikt i tak/vegger
- Skjulte vannlekkasjer (temperaturavvik)

Utføres ved temperaturdifferanse inne/ute >10°C (vinter/tidlig vår).`,
    metode: 'Termokamera (FLIR e.l.). Bilderapport med temperaturskala.',
    kostnad_min: 8000,
    kostnad_max: 15000,
    prioritet: 'anbefalt'
  },

  // ==========================================
  // DESTRUKTIVE UNDERSØKELSER
  // ==========================================
  borprove: {
    type: 'destruktiv',
    kategori: 'borprove',
    navn: 'Borprøve i treverk',
    arsak: 'Mistanke om råte eller insektangrep i bærekonstruksjon.',
    omfang: `Destruktiv prøvetaking for å verifisere:

- Råteskader (sopp, bakterier)
- Insektangrep (borebiller, termitter)
- Fuktinnhold i treverk (>16% = kritisk)
- Restbæreevne

Prøver sendes til laboratorium for analyse hvis nødvendig.`,
    metode: 'Boring/prøvestikking med tilbakeføring. Fuktmåling i borprøve.',
    kostnad_min: 5000,
    kostnad_max: 12000,
    prioritet: 'kritisk'
  },

  apning: {
    type: 'destruktiv',
    kategori: 'apning',
    navn: 'Åpning av konstruksjon',
    arsak: 'Skjult konstruksjon må inspiseres for å verifisere tilstand (f.eks. bak panel, under gulv).',
    omfang: `Kontrollert åpning av bygningsdel for å kontrollere:

- Skjult bærekonstruksjon
- Isolasjon og dampsperre
- Membran i våtrom
- Dreneringsløsninger

VIKTIG: Omfatter tilbakeføring/lukking av konstruksjon etter inspeksjon.`,
    metode: 'Kontrollert demontering og gjenoppbygging. Foto-dokumentasjon.',
    kostnad_min: 8000,
    kostnad_max: 25000,
    prioritet: 'valgfri'
  },

  // ==========================================
  // SPESIALISERTE UNDERSØKELSER
  // ==========================================
  radon: {
    type: 'spesialisert',
    kategori: 'radon',
    navn: 'Radonmåling',
    arsak: 'Radonmåling er ikke gjennomført. Anbefales for alle boliger med kjeller/sokkeletasje.',
    omfang: `Passiv radonmåling over 3 måneder (vinter/vår):

- Målepunkt: Oppholdsrom i laveste etasje
- Grenseverdi: 100 Bq/m³ (Folkehelseinstituttet)
- Tiltaksgrense: Ved >100 Bq/m³ må tiltak vurderes

Leverandører: Radonova, AirThings (ca. 1500-3000 kr)

VIKTIG: Gjennomfør måling FØR overtakelse hvis mulig.`,
    metode: 'Passiv radonmåling (3 måneder) eller elektronisk (7 dager).',
    kostnad_min: 1500,
    kostnad_max: 3000,
    prioritet: 'kritisk'
  },

  elektrisk: {
    type: 'spesialisert',
    kategori: 'elektrisk',
    navn: 'Elektrisk tilstandsrapport',
    arsak: 'Elektrisk anlegg er ikke dokumentert iht. FEL (Forskrift om elektriske lavspenningsanlegg).',
    omfang: `Elektrisk tilstandsrapport utført av autorisert elektroinstallatør:

- Kontroll av hovedtavle og sikringer
- Jordfeil og spenningsfall
- Isolasjonsmotstand
- Vurdering av alder og standard (REN-merking)
- Anbefaling om oppgradering

Påkrevd ved bygninger >20 år uten dokumentasjon.`,
    metode: 'Utføres av autorisert elektroinstallatør med FEL-kompetanse.',
    kostnad_min: 5000,
    kostnad_max: 10000,
    prioritet: 'anbefalt'
  },

  grunn: {
    type: 'spesialisert',
    kategori: 'grunn',
    navn: 'Grunnundersøkelse',
    arsak: 'Mistanke om setninger, grunnforhold eller stabilitets problemer.',
    omfang: `Geoteknisk undersøkelse for å vurdere:

- Setningsskader (sprekker, nivåforskjeller)
- Grunnforhold (bæreevne, leire, kvikkleire)
- Drenering og grunnvannsforhold
- Stabilitet (rasfare, skredfare)

Utføres av geoteknisk ingeniør.`,
    metode: 'Geoteknisk rapport med borprøver og vurdering.',
    kostnad_min: 15000,
    kostnad_max: 40000,
    prioritet: 'anbefalt'
  },

  asbest: {
    type: 'spesialisert',
    kategori: 'asbest',
    navn: 'Asbestanalyse',
    arsak: 'Bygning oppført før 1990. Mistanke om asbestholdig materiale.',
    omfang: `Asbestanalyse for å kartlegge:

- Asbestplater (eternitt)
- Isolasjonsmaterialer
- Gulvbelegg (vinyl, linoleum)
- Takmaterialer

Prøver sendes til akkreditert laboratorium.

VIKTIG: Asbest må håndteres av godkjent aktør ved riving/ombygging.`,
    metode: 'Prøvetaking og laboratorieanalyse. Asbestrisikovurdering.',
    kostnad_min: 8000,
    kostnad_max: 20000,
    prioritet: 'kritisk'
  }
}

// Kategorier for dropdown-gruppering
export const undersokelsesKategorier = {
  innvendig: {
    navn: 'Innvendige undersøkelser',
    typer: ['loft', 'krypkjeller', 'vatrom']
  },
  fukt: {
    navn: 'Fuktundersøkelser',
    typer: ['fukt_kapasitiv', 'termografi']
  },
  destruktiv: {
    navn: 'Destruktive undersøkelser',
    typer: ['borprove', 'apning']
  },
  spesialisert: {
    navn: 'Spesialiserte undersøkelser',
    typer: ['radon', 'elektrisk', 'grunn', 'asbest']
  }
}

// Hjelpefunksjon for å hente mal
export function getMal(kategori) {
  return videreUndersokelserMaler[kategori] || null
}

// Hjelpefunksjon for å liste alle maler
export function getAlleMaler() {
  return Object.keys(videreUndersokelserMaler).map(key => ({
    key,
    ...videreUndersokelserMaler[key]
  }))
}

// Prioritet-emoji mapping
export const prioritetEmoji = {
  kritisk: '🔴',
  anbefalt: '🟡',
  valgfri: '🟢'
}

// Prioritet-beskrivelse
export const prioritetBeskrivelse = {
  kritisk: 'Kritisk - Må gjennomføres før overtakelse',
  anbefalt: 'Anbefalt - Bør gjennomføres innen 6 mnd',
  valgfri: 'Valgfri - Kan vurderes ved behov'
}

// Mapping: Hvilke undersøkelser er relevante for hver bygningsdel
export const relevanteUndersokelserForBygningsdel = {
  'yttertak': ['loft', 'fukt_kapasitiv', 'termografi', 'asbest'],
  'yttervegger': ['fukt_kapasitiv', 'termografi', 'asbest'],
  'vinduer_dorer': ['fukt_kapasitiv', 'termografi'],
  'fundament_sokkel': ['krypkjeller', 'fukt_kapasitiv', 'grunn', 'borprove'],
  'drenering': ['krypkjeller', 'fukt_kapasitiv', 'grunn', 'apning'],
  'elektrisk': ['elektrisk'],
  'vvs': ['fukt_kapasitiv', 'apning', 'termografi'],
  'ventilasjon': ['loft', 'krypkjeller', 'fukt_kapasitiv'],
  'brannsikkerhet': [] // Ingen spesifikke undersøkelser
}

// Hjelpefunksjon: Filtrer kategorier basert på bygningsdeltype
export function getRelevanteCategoriesForBygningsdel(bygningsdelType) {
  const relevanteTyper = relevanteUndersokelserForBygningsdel[bygningsdelType] || []

  if (relevanteTyper.length === 0) {
    // Hvis ingen spesifikke er definert, vis alle
    return undersokelsesKategorier
  }

  // Filtrer kategorier til kun de som har minst én relevant type
  const filtrerteCategorier = {}

  Object.entries(undersokelsesKategorier).forEach(([key, kat]) => {
    const relevanteTyperIKategori = kat.typer.filter(type => relevanteTyper.includes(type))
    if (relevanteTyperIKategori.length > 0) {
      filtrerteCategorier[key] = {
        ...kat,
        typer: relevanteTyperIKategori
      }
    }
  })

  return filtrerteCategorier
}
